import React, { ReactNode } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Intent } from "~/lib/intent";
import style from "./index.module.scss";

interface TableRowActionsProps {
  children: ReactNode;
}

const isDanger = (item: React.ReactElement) =>
  (item.props as { intent?: Intent }).intent === Intent.DANGER;

export const TableRowActions = ({ children }: TableRowActionsProps) => {
  const items = React.Children.toArray(children).filter(React.isValidElement);

  if (items.length === 0) {
    return null;
  }

  const inlineItems = items.filter((item) => !isDanger(item));
  const menuItems = items.filter(isDanger);

  return (
    <div className={style.tableRowActions}>
      {inlineItems.length > 0 && (
        <div className={style.tableRowActionsButtons}>{inlineItems}</div>
      )}
      {menuItems.length > 0 && (
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <button
              type="button"
              className={style.tableRowActionsTrigger}
              aria-label="Row actions"
            >
              <i className="fa fa-ellipsis-v" />
            </button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content
              className={style.tableRowActionsContent}
              side="bottom"
              align="end"
              sideOffset={4}
            >
              <div className={style.tableRowActionsList}>
                {menuItems.map((item, index) => (
                  <DropdownMenu.Item
                    asChild
                    key={index}
                    className={style.tableRowActionsItem}
                  >
                    {item}
                  </DropdownMenu.Item>
                ))}
              </div>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      )}
    </div>
  );
}
